import React from 'react';

const OrderDetailModal = ({ unit, isOpen, onClose }) => {
    if (!isOpen || !unit) return null;

    const formatDate = (dateString) => {
        if (!dateString) return ' ';
        return new Date(dateString).toLocaleString();
    };

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {

            default: return '#6c757d';
        }
    };

    const printSingleLabel = () => {
        // Clean up any previous iframe
        const oldIframe = document.getElementById('print-iframe-single-label');
        if (oldIframe) {
            oldIframe.remove();
        }

        // Create an invisible iframe
        const iframe = document.createElement('iframe');
        iframe.id = 'print-iframe-single-label';
        iframe.style.display = 'none';
        document.body.appendChild(iframe);

        // Write the content to be printed into the iframe
        iframe.contentDocument.write(`
            <html>
                <head>
                    <title>Print Kit Label</title>
                    <style>
                        body { font-family: sans-serif; }
                        .label { border: 1px solid #ccc; padding: 20px; text-align: center; max-width: 300px; margin: 20px auto; }
                        .activation-id { font-weight: bold; font-size: 1.2em; }
                        @media print {
                            body { margin: 0.5in; }
                        }
                    </style>
                </head>
                <body>
                    <div class="label">
                        <div>Kit Unit ID:</div>
                        <div class="activation-id">${unit.ActivationID || unit.KitUnitID.slice(-8)}</div>
                    </div>
                </body>
            </html>
        `);
        iframe.contentDocument.close();

        // Set up cleanup to run after printing is done
        iframe.contentWindow.onafterprint = () => {
            iframe.remove();
        };

        // Focus and print
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
    };

    // Timeline stages in order
    const timelineStages = [
        { key: 'CreationDate', label: 'Created', icon: 'fas fa-plus-circle' },
        { key: 'ActivationDate', label: 'Activated', icon: 'fas fa-play-circle' },
        { key: 'Cargo_Delivered', label: 'Cargo Delivered', icon: 'fas fa-truck' },
        { key: 'Lab_Received', label: 'Lab Received', icon: 'fas fa-flask' }
    ];

    return (
        <div className="GORDU-modal-overlay" onClick={onClose}>
            <div className="GORDU-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="GORDU-modal-header">
                    <h2>Order Details</h2>
                    <button className="GORDU-modal-close" onClick={onClose}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>
                
                <div className="GORDU-modal-body">
                    {/* Activation ID Section - Top */}
                    <div className="GORDU-detail-section GORDU-activation-section">
                        <div className="GORDU-activation-id">
                            <span>{unit.ActivationID}</span>
                            <i className="fas fa-print" onClick={printSingleLabel} style={{ cursor: 'pointer' }}></i>
                        </div>
                    </div>

                    {/* Main Content - Left and Right Layout */}
                    <div className="GORDU-modal-main-content">
                        {/* Left Side - Kit Unit Information and Actions */}
                        <div className="GORDU-modal-left-panel">
                            {/* Kit Unit Information */}
                            <div className="GORDU-detail-section">
                                <h3>Kit Unit Information</h3>
                                <div className="GORDU-detail-grid">
                                    <div className="GORDU-detail-item">
                                        <span className="GORDU-detail-label">Unit ID:</span>
                                        <span className="GORDU-detail-value">{unit.KitUnitID}</span>
                                    </div>
                                    <div className="GORDU-detail-item">
                                        <span className="GORDU-detail-label">Kit Type ID:</span>
                                        <span className="GORDU-detail-value">{unit.KitTypeID}</span>
                                    </div>
                                    <div className="GORDU-detail-item">
                                        <span className="GORDU-detail-label">Status:</span>
                                        <span 
                                            className="GORDU-detail-status"
                                            style={{ backgroundColor: getStatusColor(unit.Status) }}
                                        >
                                            {unit.Status}
                                        </span>
                                    </div>
                                    {/* MODIFIED SECTION HERE */}
                                    <div className="GORDU-detail-item GORDU-user-info-item">
                                        {unit.userDetails ? (
                                            <>
                                                <span className="GORDU-detail-label">Assigned To:</span>
                                                <div className="GORDU-user-info-card">
                                                    <div className="GORDU-user-avatar">
                                                        {unit.userDetails.firstName?.charAt(0)}{unit.userDetails.lastName?.charAt(0)}
                                                    </div>
                                                    <div className="GORDU-user-details">
                                                        <div className="GORDU-user-name">
                                                            {unit.userDetails.firstName} {unit.userDetails.lastName}
                                                        </div>
                                                        <div className="GORDU-user-contact">
                                                            <span className="GORDU-user-phone">{unit.userDetails.phoneNumber}</span>
                                                            <span className="GORDU-user-email">{unit.userDetails.email}</span>
                                                        </div>
                                                        <div className="GORDU-user-id">ID: {unit.UserID}</div>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <span className="GORDU-detail-label">User ID:</span>
                                                <span className="GORDU-detail-value">
                                                    {unit.UserID || 'Not assigned'}
                                                </span>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Actions */}
                            <div className="GORDU-detail-section">
                                <h3>Actions</h3>
                                <div className="GORDU-action-buttons">
                                    <button className="GORDU-btn GORDU-btn-secondary">
                                        <i className="fas fa-envelope"></i>
                                        Send Notification
                                    </button>
                                    <button className="GORDU-btn GORDU-btn-secondary">
                                        <i className="fas fa-clipboard"></i>
                                        View Full History
                                    </button>
                                    <button className="GORDU-btn GORDU-btn-secondary">
                                        <i className="fas fa-exclamation-triangle"></i>
                                        Report Issue
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Right Side - Timeline */}
                        <div className="GORDU-modal-right-panel">
                            <div className="GORDU-detail-section">
                                <h3>Timeline</h3>
                                <div className="GORDU-timeline">
                                    {timelineStages.map((stage, index) => {
                                        const date = unit[stage.key];
                                        const isCompleted = !!date;
                                        const isLast = index === timelineStages.length - 1;
                                        
                                        return (
                                            <div key={stage.key} className={`GORDU-timeline-item ${isCompleted ? 'completed' : ''}`}>
                                                <div className="GORDU-timeline-connector">
                                                    <div className={`GORDU-timeline-dot ${isCompleted ? 'active' : ''}`}>
                                                        <i className={stage.icon}></i>
                                                    </div>
                                                    {!isLast && <div className={`GORDU-timeline-line ${isCompleted ? 'active' : ''}`}></div>}
                                                </div>
                                                <div className="GORDU-timeline-content">
                                                    <h4>{stage.label}</h4>
                                                    <p>{formatDate(date)}</p>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="GORDU-modal-footer">
                    <button className="GORDU-btn GORDU-btn-secondary" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default OrderDetailModal;